import { z } from 'zod';

/**
 * Interface representing the parameters used to make a content/record uri
 * @member type - type of the image (ex: user, fileArticle, spot, diffgroup, etc.)
 * @member recordId - id of the record
 */
export const typeIdSchema = z.object({
    type: z.string(),
    recordId: z.union([z.string().regex(new RegExp('[0-9]+')), z.number()]),
});
export type TypeId = z.infer<typeof typeIdSchema>;
export const ensureTypeId = (o: unknown, passThrough?: boolean): o is TypeId => {
    const schema = passThrough ? typeIdSchema.passthrough() : typeIdSchema;
    return schema.safeParse(o).success;
};

/**
 * @member uri - uri of the record
 */
export const uriSchema = z.object({
    uri: z.string().regex(new RegExp('[a-zA-Z]+/[0-9]+')),
});
export type Uri = z.infer<typeof uriSchema>;
export const ensureUri = (o: unknown, passThrough?: boolean): o is Uri => {
    const schema = passThrough ? uriSchema.passthrough() : uriSchema;
    return schema.safeParse(o).success;
};

/**
 * Type with one of (tuple type - id) and (uri) required. If both are passed, only the uri will be used
 */
export const uriOrTypeIdSchema = typeIdSchema.partial().or(uriSchema.partial());
export type UriOrTypeId = z.infer<typeof uriOrTypeIdSchema>;
